<template>
  <component :is="type === 'fixed' ? Teleport : 'div'" v-if="isChinese()" to="body">
    <div :class="['x-attract flex justify-center items-center', { fixed: type === 'fixed' }]">
      <Resource class="qrcode" :src="url || src"></Resource>
      <div class="words ml-[12px]">
        <div class="title">扫一扫</div>
        <div class="desc">获取最新资讯福利</div>
      </div>
    </div>
  </component>
</template>

<script setup lang="ts">
import { Teleport } from 'vue';
import type { AttractSource } from './constant';
import { isChinese } from '~/utils/area';
import Resource from '~/components/resource/index';
import { transformImage } from '~/utils';

const props = withDefaults(
  defineProps<{
    source?: AttractSource;
    url?: string;
    type: 'inline' | 'fixed';
  }>(),
  {
    type: 'inline',
  },
);

const src = computed(() =>
  transformImage(getFeUrl(`/youyan-platform/png/qrcode/${props.source}-qrcode.png`)),
);
</script>

<style lang="scss" scoped>
.title {
  color: var(--text-1);
  font-weight: 500;
  line-height: 24px;
}
.desc {
  color: var(--text-1-60);
}
.fixed {
  background: #ffffff;
  box-shadow: 0px 6px 20px 0px rgba(21, 46, 106, 0.08);
  border-radius: 12px;
  padding: 24px;
  position: fixed;
  left: 20px;
  bottom: 320px;
}
.qrcode {
  width: 100px;
  height: 100px;
}
.words {
  margin-top: 6px;
  line-height: 18px;
  font-size: 14px;
}
</style>
